import { render, staticRenderFns } from "./KnowledgeSearchScreen.vue?vue&type=template&id=bdd4217a&scoped=true&"
import script from "./KnowledgeSearchScreen.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeSearchScreen.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeSearchScreen.vue?vue&type=style&index=0&id=bdd4217a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd4217a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VProgressCircular,VSpacer})
